// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__HhtoB","item":"PaymentsMobile_item__2ixsO","label":"PaymentsMobile_label__2nnHX","amount":"PaymentsMobile_amount__3uEJN"};